import { Injectable } from '@angular/core';
import { ApiService } from "../api.service";

const PATH = "integration-providers";

@Injectable({
  providedIn: 'root'
})
export class IntegrationProvidersHandlerService {

  constructor(private APIService: ApiService) { }

  getIntegrationProviders(masterAccountID: number,){
    return this.APIService.get(`${PATH}/${masterAccountID}`, {
    })
  }

}
